/* eslint-disable no-console */
import React from 'react';
import ReactDOM from 'react-dom';

import AlertApp from './AlertApp';

/**
 * Singleton with all alerts by elementId key.
 */
const alertsSingleton = {};

function findIndex(elementId, alertKey) {
  return alertsSingleton[elementId].findIndex(
    (a) => a.alertKey === alertKey
  );
}

function renderAlerts(elementId) {
  ReactDOM.render(
    <AlertApp
      alerts={alertsSingleton[elementId]}
      onClose={(alertKey) => {
        const index = findIndex(elementId, alertKey);

        if (index > -1) {
          alertsSingleton[elementId][index].onClose?.();
        }

        window.closeAlert(elementId, alertKey);
      }}
    />,
    document.getElementById(elementId)
  );
}

/**
 * Append alert into defined elementId
 * @param {object} config Alert entity. Use the alertKey property to avoid repeating the same alert.
 * @param {string} elementId Id from element to render
 */
window.appendAlert = (config, elementId) => {
  if (!config.alertKey) {
    console.error(
      "You must define 'alertKey' in config param from appendAlert()"
    );
    return false;
  }

  if (!alertsSingleton[elementId]) {
    alertsSingleton[elementId] = [];
  }

  if (!findIndex(elementId, config.alertKey)) {
    return false;
  }

  alertsSingleton[elementId].push(config);

  renderAlerts(elementId);

  return true;
};

/**
 * Close and remove the alert.
 * @param {string} elementId Element where the alert was rendered
 * @param {string} alertKey Alert identifier
 */
window.closeAlert = (elementId, alertKey) => {
  const index = findIndex(elementId, alertKey);

  if (index > -1) {
    alertsSingleton[elementId].splice(index, 1);
    renderAlerts(elementId);
  }
};
